import React from 'react'

const Home = () => {
  return (
    <div>
        <h1 style={{"text-align":"center"}}> THIS IS HOME PAGE</h1>
        
    </div>
  )
}

export default Home